import { createSelector } from 'reselect'
import { PURCHASE_STATE } from './constants'

export const getCustomerData = state => state[PURCHASE_STATE]
export const getCustomerEmail = state => state[PURCHASE_STATE]?.email
export const getHolders = state => state[PURCHASE_STATE]?.holders
export const getInsuranceIds = state => state[PURCHASE_STATE]?.insuranceIds
export const getIsMandatory = state => state[PURCHASE_STATE]?.isMandatory

export const getPurchaseEmail = createSelector([getCustomerEmail, getHolders], (email, holders) => {
  return holders[0]?.email || email
})
